import { computed, ComputedRef, inject, provide } from "vue";
import { LanguageCodes } from "@fresh8/types/src/language";
import { Language } from "./lang/langType";

import english from "./lang/english";
import english_us from "./lang/englishUS";
import english_ca from "./lang/englishCA";
import german from "./lang/german";
import spanish from "./lang/spanish";
import portuguese from "./lang/portuguese";
import brazilian from "./lang/brazilian";
import greek from "./lang/greek";
import french from "./lang/french";
import danish from "./lang/danish";
import swedish from "./lang/swedish";
import finnish from "./lang/finnish";
import swahili from "./lang/swahili";
import italian from "./lang/italian";
import bulgarian from "./lang/bulgarian";
import dutch from "./lang/dutch";
import estonian from "./lang/estonian";
import russian from "./lang/russian";

export const Languages = {
  en: english,
  "en-en": english,
  "en-gb": english,
  "en-us": english_us,
  "en-ca": english_ca,
  de: german,
  "de-de": german,
  "de-at": german,
  "de-li": german,
  "de-lu": german,
  "de-ch": german,
  es: spanish,
  "es-es": spanish,
  pt: portuguese,
  "pt-pt": portuguese,
  "pt-br": brazilian,
  el: greek,
  "el-gr": greek,
  fr: french,
  "fr-fr": french,
  da: danish,
  "da-dk": danish,
  sv: swedish,
  "sv-SE": swedish,
  fi: finnish,
  "fi-fi": finnish,
  sw: swahili,
  "sw-ke": swahili,
  it: italian,
  "it-it": italian,
  "it-ch": italian,
  nl: dutch,
  "nl-nl": dutch,
  "nl-be": dutch,
  bg: bulgarian,
  "bg-bg": bulgarian,
  et: estonian,
  "et-ee": estonian,
  ru: russian,
  "ru-ru": russian
};

export interface Lang {
  lang: LanguageCodes;
}

export function createLang(lang: string): { lang: ComputedRef<LanguageCodes> } {
  return {
    lang: computed(() =>
      Languages[lang] !== undefined
        ? (lang as LanguageCodes)
        : ("en" as LanguageCodes)
    )
  };
}

export type LangContext = ReturnType<typeof createLang>;
export const LangSymbol = Symbol("LangCompSymbol");

export function injectLang(): LangContext | undefined {
  return inject<LangContext>(LangSymbol);
}

export function provideLang(lang: string): void {
  provide(LangSymbol, createLang(lang));
}

export function getTranslation(lang: string): Language {
  return Languages[lang] ? Languages[lang] : Languages["en"];
}
